import { createEvent } from "library/local-events/index.mjs"

/**
 * Raised when the user selects a different content language.
 * Semantic signal distinct from the useReferenceState storage event.
 */
export const ContentLanguageChanged = createEvent("ContentLanguageChanged")

/**
 * Raised when translation state changes (loading, data arrived, language switch).
 * Components that call useTranslationContext() subscribe to this event via
 * useRefresh(noChange), so only interested components re-render.
 */
export const TranslationStateChanged = createEvent("TranslationStateChanged")
